import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { AddBlogsListComponent } from './Components/add-blogs-list/add-blogs-list.component';
import { AddBlogsComponent } from './Components/add-blogs/add-blogs.component';
import { AddNewsComponent } from './Components/add-news/add-news.component';
import { AskAnExpertComponent } from './Components/ask-an-expert/ask-an-expert.component';
// import { MicrosoftloginGuard } from './auth/microsoftlogin.guard';
import { DocumentComponent } from './Components/document/document.component';
import { FertilizerRemainderComponent } from './Components/fertilizer-remainder/fertilizer-remainder.component';
import { FertilizerlistComponent } from './Components/fertilizerlist/fertilizerlist.component';
import { GovtSchemesListComponent } from './Components/govt-schemes-list/govt-schemes-list.component';
import { GovtSchemeComponent } from './Components/govt-schemes/govt-schemes.component';
import { HeaderComponent } from './Components/header/header.component';
import { HomeComponent } from './Components/home/home.component';
import { InAppReviewComponent } from './Components/in-app-review/in-app-review.component';
import { LoginComponent } from './Components/login/login.component';
import { MarketRateHistoricalDataComponent } from './Components/market-rate-historical-data/market-rate-historical-data.component';
import { MarketplaceComponent } from './Components/marketplace/marketplace.component';
import { NewsHistoricalDataComponent } from './Components/news-historical-data/news-historical-data.component';
import { ProductListComponent } from './Components/product-list/product-list.component';
import { SureveyConductComponent } from './Components/surevey-conduct/surevey-conduct.component';
import { SureveyDataComponent } from './Components/surevey-data/surevey-data.component';
import { UserViewComponent } from './Components/user-view/user-view.component';
import { TrackYourHarvestComponent } from './track-your-harvest/track-your-harvest.component';
import { AccessControlComponent } from './Components/access-control/access-control.component';
import { TransactionListComponent } from './Components/transaction-list/transaction-list.component';
import { DocumentHistoryComponent } from './Components/document-history/document-history.component';
import { SettingComponent } from './Components/setting/setting.component';
import { UnauthorizedPageComponent } from './Components/unauthorized-page/unauthorized-page.component';
import { AuthGuardGuard } from './Service/auth-guard.guard';
import { SessionExpireComponent } from './Components/session-expire/session-expire.component';
import { DiscussionBoardComponent } from './Components/discussion-board/discussion-board.component';
import { DiscussionBoardAskPageComponent } from './Components/discussion-board-ask-page/discussion-board-ask-page.component';
import { DiscussionBoardDetailsComponent } from './Components/discussion-board-details/discussion-board-details.component';
import { DiscussionboardGuidelinesComponent } from './Components/discussionboard-guidelines/discussionboard-guidelines.component';
import { BannerManagementComponent } from './Components/banner-management/banner-management.component';
import { VideoLibraryComponent } from './Components/video-library/video-library.component';
import { PostAVideoComponent } from './Components/post-a-video/post-a-video.component';
import { AddHarvestCropComponent } from './track-your-harvest/add-harvest-crop/add-harvest-crop.component';
import { DominateMarketComponent } from './Components/dominate-market/dominate-market.component';
const routes: Routes = [
  // { path: '', redirectTo: 'login', pathMatch: 'full' },
  //  { path: '', component : LoginComponent},
  {
    // Needed for hash routing
    path: 'error',
    component: UserViewComponent, canActivate: [MsalGuard, AuthGuardGuard]
  },
  {
    // Needed for hash routing
    path: 'state',
    component: UserViewComponent, canActivate: [MsalGuard]
  },
  {
    // Needed for hash routing
    path: 'code',
    component: UserViewComponent, canActivate: [MsalGuard]
  },
  { path: '', component: UserViewComponent, canActivate: [MsalGuard] },
  { path: 'document', component: DocumentComponent, canActivate: [MsalGuard, AuthGuardGuard] },
  // { path :'user', component: UserViewComponent,canActivate: [MsalGuard]},
  { path: 'Govt-schemes', component: GovtSchemeComponent, canActivate: [MsalGuard] },
  { path: 'MarketPlace', component: MarketplaceComponent, canActivate: [MsalGuard] },
  { path: 'Fertilizer', component: FertilizerRemainderComponent, canActivate: [MsalGuard, AuthGuardGuard] },
  { path: 'FertilizerList', component: FertilizerlistComponent, canActivate: [MsalGuard, AuthGuardGuard] },
  { path: 'in-app-review', component: InAppReviewComponent, canActivate: [MsalGuard, AuthGuardGuard] },
  { path: 'track-your-harvest', component: TrackYourHarvestComponent, canActivate: [MsalGuard, AuthGuardGuard] },
  { path: 'Govt-schemes-list', component: GovtSchemesListComponent, canActivate: [MsalGuard, AuthGuardGuard] },
  { path: 'ask-an-expert', component: AskAnExpertComponent, canActivate: [MsalGuard, AuthGuardGuard] },
  { path: 'market-rate-historical-data', component: MarketRateHistoricalDataComponent, canActivate: [MsalGuard, AuthGuardGuard] },
  { path: 'dominant-market', component: DominateMarketComponent, canActivate: [MsalGuard, AuthGuardGuard] },
  { path: 'add-blog', component: AddBlogsComponent, canActivate: [MsalGuard] },
  { path: 'add-blog-list', component: AddBlogsListComponent, canActivate: [MsalGuard, AuthGuardGuard] },
  { path: 'news-historical-data', component: NewsHistoricalDataComponent, canActivate: [MsalGuard, AuthGuardGuard] },
  { path: 'add-news', component: AddNewsComponent, canActivate: [MsalGuard] },
  { path: 'survey-data', component: SureveyDataComponent, canActivate: [MsalGuard, AuthGuardGuard] },
  { path: 'access-control', component: AccessControlComponent, canActivate: [MsalGuard, AuthGuardGuard] },
  { path: 'MarketPlace', component: MarketplaceComponent, canActivate: [MsalGuard, AuthGuardGuard] },
  { path: 'survey-conduct', component: SureveyConductComponent, canActivate: [MsalGuard, AuthGuardGuard] },
  { path: 'product-list', component: ProductListComponent, canActivate: [MsalGuard, AuthGuardGuard] },
  { path: 'transaction-list', component: TransactionListComponent, canActivate: [MsalGuard, AuthGuardGuard] },
  { path: 'document-verification-history/:personId', component: DocumentHistoryComponent, canActivate: [MsalGuard] },

  { path: 'setting', component: SettingComponent, canActivate: [MsalGuard, AuthGuardGuard] },
  { path: 'session-expire', component: SessionExpireComponent, canActivate: [MsalGuard] },
  { path: 'unauthorized-page', component: UnauthorizedPageComponent, canActivate: [MsalGuard] },
  { path: 'discussionboard', component: DiscussionBoardComponent, canActivate: [MsalGuard] },
  { path: 'discussionboard-ask-page', component: DiscussionBoardAskPageComponent, canActivate: [MsalGuard] },
  { path: 'discussionboard-details', component: DiscussionBoardDetailsComponent, canActivate: [MsalGuard] },
  { path: 'discussionboard-guidelines', component: DiscussionboardGuidelinesComponent, canActivate: [MsalGuard] },
  { path: 'banner-Management', component: BannerManagementComponent, canActivate: [MsalGuard] },
  { path: 'video-library', component: VideoLibraryComponent, canActivate: [MsalGuard, AuthGuardGuard] },
  { path: 'post-a-video', component: PostAVideoComponent, canActivate: [MsalGuard, AuthGuardGuard] },
  { path: 'add-harvest-crop', component: AddHarvestCropComponent, canActivate: [MsalGuard] },

]



// const isIframe = window !== window.parent && !window.opener;
// const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: true,
    // Don't perform initial navigation in iframes
    // initialNavigation: !isIframe ? 'enabled' : 'disabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
